/**
 * AG Grid Enterprise Configuration
 *
 * This file contains the AG Grid Enterprise license key configuration.
 * The license key is centrally managed here to avoid duplication across
 * multiple environment files.
 *
 * License Details:
 * - Valid until: July 10, 2026
 * - License Type: Single Application Developer License
 * - Application: Zuper Pro
 */

export const AG_GRID_LICENSE_KEY = 'Using_this_{AG_Grid}_Enterprise_key_{AG-080857}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Zuper_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Zuper_Pro}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Zuper_Pro}_need_to_be_licensed___{Zuper_Pro}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{10_July_2026}____[v3]_[01]_MTc4MzYzODAwMDAwMA==ea11d1c14ddcf80f6602c063c9bdc5ed';
